import $ from 'jquery';
import {Easings, smoothy} from "../Libraries/smoothy";

$('.back-to-top').on('click', function () {
    smoothy(0, 1000, Easings.easeOutQuint);
});

toggleBackToTop();
$(document).on('scroll', function () {
    toggleBackToTop();
});

function toggleBackToTop() {
    if ($(document).scrollTop() < 720) {
        $('.back-to-top').addClass('hide');
    } else {
        $('.back-to-top').removeClass('hide');
    }
}
